import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import type { Booking } from "../../api/bookings";
import type { BookingModal } from "../../store/bookingsSlice";

interface BookingActionsMenuProps {
  booking: Booking;
  onAction: (action: BookingModal, booking: Booking) => void;
}

export const BookingActionsMenu: React.FC<BookingActionsMenuProps> = ({
  booking,
  onAction,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isConfirmed = booking.status === "confirmed";

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleAction = (action: BookingModal) => {
    handleClose();
    onAction(action, booking);
  };

  return (
    <>
      <IconButton
        aria-label="booking actions"
        size="small"
        onClick={handleOpen}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleAction("edit")}>Edit Booking</MenuItem>
        {isConfirmed && (
          <MenuItem onClick={() => handleAction("reschedule")}>
            Reschedule
          </MenuItem>
        )}
        {isConfirmed && (
          <MenuItem onClick={() => handleAction("cancel")}>
            Cancel Booking
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
